// stepOneValidation.js
import * as Yup from 'yup';
import { isPastDate, isAtLeast18 } from './validationHelpers';

const isLessThan2Years = (value) => {
  if (!value) return false;
  const date = new Date(value);
  const twoYearsAgo = new Date();
  twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
  return date > twoYearsAgo;
};

const conditionalRequired = (type = 'string') =>
  Yup[type]().when('address_since', {
    is: isLessThan2Years,
    then: Yup[type]().required('This field is required'),
    otherwise: Yup[type]().notRequired()
  });

export const stepOneSchema = Yup.object().shape({
  promo_code: Yup.string().max(50, 'Promo Code should not exceed 50 characters'),
  first_name: Yup.string()
    .required('First Name is required')
    .max(150, 'First Name should not exceed 150 characters')
    .matches(/^[a-zA-Z\s]*$/, 'First Name should contain only letters and spaces'),
  last_name: Yup.string()
    .required('Last Name is required')
    .max(150, 'Last Name should not exceed 150 characters')
    .matches(/^[a-zA-Z\s]*$/, 'Last Name should contain only letters and spaces'),
  dob: Yup.date()
    .required('Date of Birth is required')
    .typeError('Date of Birth must be a valid date')
    .test('is-18', 'You must be at least 18 years old', isAtLeast18),
  phone_1: Yup.string()
    .required('Phone Number is required')
    .matches(/^\d{3}-\d{3}-\d{4}$/, 'Phone Number should be 10 digits (e.g., 123-456-7890)'),
  email: Yup.string()
    .required('Email is required')
    .email('Email must be a valid email'),
  address_1: Yup.string()
    .required('Street Address is required')
    .max(150, 'Street Address should not exceed 150 characters'),
  address_2: Yup.string()
    .max(50, 'Apt/Unit should not exceed 50 characters'),
  city: Yup.string()
    .required('City is required')
    .max(100, 'City should not exceed 100 characters')
    .matches(/^[a-zA-Z\s]*$/, 'City should contain only letters and spaces'),
  state: Yup.string()
    .required('State is required')
    .matches(/^[A-Z]{2}$/, 'State should be a valid two-letter code'),
  zip: Yup.string()
    .required('Zip Code is required')
    .matches(/^\d{5}$/, 'Zip Code must be exactly 5 digits',  val => val && /^\d{5}$/.test(val)),
  address_since: Yup.date()
    .required('Current Address Since is required')
    .typeError('Current Address Since must be a valid date')
    .test('is-past', 'Current Address Since date cannot be in the future', isPastDate),
     // Dynamically conditionally required fields
 // Dynamically required past address fields based on `address_since`
past_address_1: Yup.string().when('address_since', {
  is: isLessThan2Years,
  then: (schema) => schema.required('Previous Street Address is required'),
  otherwise: (schema) => schema.notRequired()
}),

past_address_2: Yup.string().notRequired(),

past_city: Yup.string().when('address_since', {
  is: isLessThan2Years,
  then: (schema) =>
    schema
      .required('Previous City is required')
      .matches(/^[a-zA-Z\s]*$/, 'City should contain only letters and spaces')
      .max(100, 'City should not exceed 100 characters'),
  otherwise: (schema) => schema.notRequired()
}),

past_state: Yup.string().when('address_since', {
  is: isLessThan2Years,
  then: (schema) => schema
    .required('Previous State is required')
    .matches(/^[A-Z]{2}$/, 'State should be a valid two-letter code'),
  otherwise: (schema) => schema.notRequired()
}),

past_zip: Yup.string().when('address_since', {
  is: isLessThan2Years,
  then: (schema) => schema
    .required('Previous Zip Code is required')
    .matches(/^\d{5}$/, 'Zip Code must be exactly 5 digits'),
  otherwise: (schema) => schema.notRequired()
}),

past_movein_date: Yup.date().when('address_since', {
  is: isLessThan2Years,
  then: (schema) =>
    schema
      .required('Previous Move-in Date is required')
      .max(Yup.ref('address_since'), 'Move-in date must be before current address start date'),
  otherwise: (schema) => schema.notRequired(),
}),

past_moveout_date: Yup.date().when('address_since', {
  is: isLessThan2Years,
  then: (schema) =>
    schema
      .required('Previous Move-out Date is required')
      .max(Yup.ref('address_since'), 'Move-out date must be before current address start date'),
  otherwise: (schema) => schema.notRequired(),
}),

});

